import { _ as __rest } from './tslib.es6-b97b9ccd.js';
import React__default from 'react';
import { Modal as Modal$1 } from '@mantine/core';
import { u as useStyles } from './index.styles-2ae2bbf8.js';

const Modal = (_a) => {
    var { styles, classNames, transitionProps } = _a, rest = __rest(_a, ["styles", "classNames", "transitionProps"]);
    const { classes } = useStyles(undefined, {
        name: 'Modal',
        styles,
        classNames,
    });
    return (React__default.createElement(Modal$1, Object.assign({ centered: true, classNames: classes, transitionProps: Object.assign({ transition: 'fade' }, transitionProps) }, rest)));
};

export { Modal as M };
